import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { VitrineLoja } from '@/pages/fichas/types';

// Menor preço das fichas à venda neste evento (para a linha "Fichas a partir
// de R$ 60,00" no rodapé). Usa a MESMA consulta da vitrine (loja_vitrine) e só
// roda quando o evento realmente vende fichas. Sem preço, devolve null e a
// linha simplesmente não aparece.
export function usePrecoFichas(eventoId: number | null, ativo: boolean): number | null {
  const [preco, setPreco] = useState<number | null>(null);

  useEffect(() => {
    if (!eventoId || !ativo) {
      setPreco(null);
      return;
    }
    let vivo = true;
    supabase
      .rpc('loja_vitrine', { p_evento: eventoId })
      .then(({ data, error }) => {
        if (!vivo || error) return;
        const vitrine = data as VitrineLoja | null;
        const produtos = (vitrine?.pontos ?? [])
          .flatMap((p) => p.produtos)
          .filter((p) => p.situacao === 'a_venda');
        if (produtos.length > 0) {
          setPreco(Math.min(...produtos.map((p) => p.preco_centavos)));
        }
      });
    return () => {
      vivo = false;
    };
  }, [eventoId, ativo]);

  return preco;
}